export default "__VITE_PUBLIC_ASSET__58e925de__"